import ApiClient from './client';
import { ApiError } from './error';

const EVENT_RELATIONS = {
	SPORT:                     'sport',
	SPORT_CATEGORY_PARENTS:    'sport.categoryParents',
	SCORES:                    'scores',
	TEAM_HOME:                 'teamHome',
	TEAM_GUEST:                'teamGuest',
	ANALYTICS_PLAYS:           'analyticsPlays',
	VENUE:                     'venue',
	LOCATION:                  'location',
	IMAGE:                     'image',
	IMAGES:                    'images',
	STREAMS:                   'streams',
	SOCIAL_ACCOUNTS:           'socialAccounts',
	PARTICIPANTS:              'participants',
	PARTICIPANTS_PARTICITABLE: 'participants.participatable',
	PARTICIPANT_CONTEXT:       'participants.context',
	PERIODS:                   'periods',
	ADS:                       'ads',
	CATEGORY_PARENT:           'categoryParent',
	CATEGORY_CHILD:            'categoryChild',
	LEAGUE:                    'league',
};

export { EVENT_RELATIONS };

export { ApiError };

export default ApiClient;
